import { AuthService } from '../../Services/auth.service';
import { Component, OnInit } from '@angular/core';
import { CourseService } from '../../Services/course.service';
// import * as $ from 'jquery';
import Swal from 'sweetalert2';
import { lowerFirst } from 'lodash';


@Component({
  selector: 'app-course-list',
  template: require('./course-list.component.html'),
  styles: [require('./course-list.component.css')]
})


export class CourseListComponent implements OnInit {
  courses: any[] = [];
  SelectedCourses: any[]=[];
  loading: boolean = false;
  categories: any[] = [];
  selectedCat: string ="1";
  selectedSort: string = "rasc";
  
  isEditor: boolean =false;
  isBaanKapitein: boolean = false;
  isAdmin:boolean = false;
  isLoggedIn:boolean = false;
  showReversedTrack:boolean = false;

  CurrentSelectedCourseID = -1;
  CurrentSelectedCourseKm:number = 0;
  CurrentSelectedCourseHm:number = 0;
  CurrentSelectedCourseTitle:string = "";
  

  constructor(private courseService: CourseService, private auth: AuthService) {
  }

  ngOnInit() {
    
    this.isEditor = this.auth.isInRole('CourseEditor')
    this.isBaanKapitein = this.auth.isInRole('baankapitein')
    this.isAdmin = this.auth.isInRole('admin')
    this.isLoggedIn = this.auth.isAuthenticated();

    // console.log("this.isAdmin: "+this.isAdmin+" this.isBaanKapitein: "+this.isBaanKapitein+" this.isEditor: "+this.isEditor + " this.isLoggedIn: "+this.isLoggedIn);
    
    this.loading = true;
    // console.log("loading: "+this .loading);
    this.courseService.getAllCourses().subscribe(
      g => {
        this.courses = g;
        this.loading = false;
        this.SelectionChanged();
      }
    );

    this.courseService.getCourseCategories().subscribe( x =>{
      this.categories = x;
      // console.log(x);
    });

    // (<any>$('[data-toggle="popover"]')).popover();
    // (<any>$('.autoHidePopover')).popover().click(function () {
    //   setTimeout(function () {
    //     (<any>$('.autoHidePopover')).popover('hide');
    //   }, 5000);
    // });

  }

  SelectionChanged(){
    // console.log("selection changed")
    this.SelectedCourses =  this.courses.filter(c => {
      return c.courseCategoryId == this.selectedCat
    });

    switch (this.selectedSort){
      case "rasc": {
        this.SelectedCourses.sort((a,b) => (a.courseNr > b.courseNr) ? 1 : ((b.courseNr > a.courseNr) ? -1 : 0))
        break;
      }
      case "rdesc": {
        this.SelectedCourses.sort((a,b) => (b.courseNr > a.courseNr) ? 1 : ((a.courseNr > b.courseNr) ? -1 : 0));
        break;
      }
      case "distasc": {
        this.SelectedCourses.sort((a,b) => (a.distance > b.distance) ? 1 : ((b.distance > a.distance) ? -1 : 0))
        break;
      }
      case "distdesc": {
        this.SelectedCourses.sort((a,b) => (b.distance > a.distance) ? 1 : ((a.distance > b.distance) ? -1 : 0));
        break;
      }
      case "hasc": {
        this.SelectedCourses.sort((a,b) => (a.altitudeMeters > b.altitudeMeters) ? 1 : ((b.altitudeMeters > a.altitudeMeters) ? -1 : 0))
        break;
      }
      case "hdesc": {
        this.SelectedCourses.sort((a,b) => (b.altitudeMeters > a.altitudeMeters) ? 1 : ((a.altitudeMeters > b.altitudeMeters) ? -1 : 0));
        break;
      }
      case "grasc": {
        this.SelectedCourses.sort((a,b) => (a.gr > b.gr) ? 1 : ((b.gr > a.gr) ? -1 : 0))
        break;
      }
      case "grdesc": {
        this.SelectedCourses.sort((a,b) => (b.gr > a.gr) ? 1 : ((a.gr > b.gr) ? -1 : 0));
        break;
      }
    }
  }

  checkClick(s:string){
    switch (s) {
      case "rn":
        if (this.selectedSort == "rasc"){
          this.selectedSort = "rdesc"
        }
        else{
          this.selectedSort = "rasc"
        }
        break;
      case "asc":
        if (this.selectedSort == "hasc" ){
          this.selectedSort = "hdesc"
        }
        else{
          this.selectedSort = "hasc"
        }
        break;
      case "gr":
        if (this.selectedSort == "grasc" ){
          this.selectedSort = "grdesc"
        }
        else{
          this.selectedSort = "grasc"
        }
        break;
      case "distance":
        if (this.selectedSort == "distasc" ){
          this.selectedSort = "distdesc"
        }
        else{
          this.selectedSort = "distasc"
        }
        break;
      default:
        break;
    }
    this.SelectionChanged();
  }

  showInformation(id: number){
    var i = this.courses.find( c => c.id == id);
    Swal.fire({
      title: 'Waar gaat dit naartoe?',
      text: i.longDescription,
      type: 'info',
      showCloseButton: false,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok',
    })
  }

  showExtraInfo(id: number){
    
    
    var i = this.courses.find( c => c.id == id);
    
    var extraInfo = i.extraInfo.replace(/\n/g,'<br>');
    var innerhtml = `
      <div class="text-left mt-5">
        ${extraInfo}
      </div>
    `
    
    Swal.fire({
      title: 'Extra informatie',
      html: innerhtml,
      type: 'info',
      showCloseButton: false,
      showCancelButton: false,
      // backdrop:false,
      focusConfirm: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok',
    })
  }

  SetCurrentCourseID(id:number){
    // console.log("Setting current id: "+id);
    this.CurrentSelectedCourseID = id;

    this.courseService.getCourse(this.CurrentSelectedCourseID).subscribe( (res:any)=>{
      this.CurrentSelectedCourseKm = res.distance;
      this.CurrentSelectedCourseHm = res.altitudeMeters;
      this.CurrentSelectedCourseTitle = res.name;
    })

  }

  // ngAfterViewInit(){
  //   console.log("View of course list");
    
  // }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/course-list/course-list.component.ts